import { z } from 'zod';
import { MediaSchema } from './medias.js';
import { DateCivileSchema, ProseBilingueSchema, SlugSchema, TexteBilingueSchema, } from './textes.js';
/** Une foire est une exposition hors les murs, avec un stand (section 3.4). */
export const TYPES_EXPOSITION = ['exposition', 'foire'];
export const TypeExpositionSchema = z.enum(TYPES_EXPOSITION);
/**
 * L'état est **porté par la donnée**, pas déduit d'une horloge : le moteur est
 * une fonction pure, deux publications des mêmes données donnent le même HTML.
 * C'est la régie qui fait passer une exposition d'un état à l'autre, comme
 * elle pose le statut d'une œuvre (D13).
 */
export const ETATS_EXPOSITION = ['a-venir', 'en-cours', 'passee'];
export const EtatExpositionSchema = z.enum(ETATS_EXPOSITION);
export const LieuSchema = z.object({
    nom: z.string().min(1),
    adresse: z.string().min(1).optional(),
    ville: z.string().min(1),
    pays: z.string().length(2),
});
export const VernissageSchema = z.object({
    date: DateCivileSchema,
    debut: z.string().regex(/^([01]\d|2[0-3]):[0-5]\d$/),
    fin: z
        .string()
        .regex(/^([01]\d|2[0-3]):[0-5]\d$/)
        .optional(),
    note: TexteBilingueSchema.optional(),
});
export const ExpositionSchema = z
    .object({
    slug: SlugSchema,
    type: TypeExpositionSchema,
    titre: TexteBilingueSchema,
    /** « Exposition personnelle », « huit artistes ». */
    sousTitre: TexteBilingueSchema.optional(),
    dateDebut: DateCivileSchema,
    dateFin: DateCivileSchema,
    vernissage: VernissageSchema.optional(),
    lieu: LieuSchema,
    /** Numéro de stand : propre aux foires. */
    stand: z.string().min(1).optional(),
    texte: ProseBilingueSchema.optional(),
    artistes: z.array(SlugSchema),
    oeuvres: z.array(SlugSchema),
    vuesAccrochage: z.array(MediaSchema),
    etat: EtatExpositionSchema,
})
    .refine((e) => e.dateDebut <= e.dateFin, 'la date de fin doit suivre la date de début')
    .refine((e) => e.type === 'foire' || e.stand === undefined, 'un stand ne se déclare que sur une foire');
//# sourceMappingURL=expositions.js.map